import React, { useState, useContext, useMemo } from "react";
import "./styles.css";
import { useParams } from "react-router-dom";
import { Paper } from "@mui/material";
import authentication from "../../utils/authentication";
import { api } from "../../service/Api";
import { MyContext } from "../../Context";
import "./Modal.css";

/* --- util: base64/base64url decode seguro --- */
function safeB64Decode(input) {
    if (!input) return null;
    try {
        let s = String(input).replace(/-/g, "+").replace(/_/g, "/");
        const pad = s.length % 4;
        if (pad) s += "=".repeat(4 - pad);
        if (typeof window !== "undefined" && typeof window.atob === "function") {
            return decodeURIComponent(
                Array.prototype.map
                    .call(window.atob(s), function (c) {
                        return "%" + c.charCodeAt(0).toString(16).padStart(2, "0");
                    })
                    .join("")
            );
        }
        // fallback Node (caso haja SSR)
        return Buffer.from(s, "base64").toString("utf-8");
    } catch {
        return null;
    }
}

/* --- Botão de nota (memo p/ evitar re-render desnecessário) --- */
const BtnExpand = React.memo(function BtnExpand({ valor, nota, cor, id_pergunta, selected, onSelect }) {
    return (
        <button
            type="button"
            className="ps-scale-btn"
            aria-pressed={selected}
            style={{ "--scale-color": cor }}
            onClick={() => onSelect(nota, id_pergunta)}
        >
            <span className="ps-scale-dot" aria-hidden="true" />
            {valor}
        </button>
    );
});const BodyElement = ({ pergunta, id_pergunta, tipo }) => {
    const { cnes } = useParams();

    const {
        question, setQuestion,
        id_perguntaAv, setIdPerguntaAv,
        notaAv, setNota,
        obsAv, setObsAv,
    } = useContext(MyContext);

    const [isModalOpen, setIsModalOpen] = useState(true);
    const [saving, setSaving] = useState(false);
    const [errMsg, setErrMsg] = useState("");

    const cnesDecoded = useMemo(() => safeB64Decode(cnes) || cnes || "", [cnes]);
    const authToken = useMemo(
        () => (cnesDecoded ? authentication[cnesDecoded] : undefined),
        [cnesDecoded]
    );

    const options = [
        { nota: 1, label: "Péssimo", cor: "#D8483B" },
        { nota: 2, label: "Ruim", cor: "#DB8A45" },
        { nota: 3, label: "Regular", cor: "#C99A2E" },
        { nota: 4, label: "Bom", cor: "#6FA24A" },
        { nota: 5, label: "Ótimo", cor: "#2E9463" },
    ];

    const onSelect = (nota, idPerg) => {
        setNota(nota);
        setIdPerguntaAv(idPerg);
    };

    async function handleSalvar() {
        try {
            setErrMsg("");

            if (!notaAv || !id_perguntaAv) {
                setErrMsg("Selecione uma opção antes de salvar.");
                return;
            }
            setSaving(true);

            const param = {
                nota: notaAv,
                id_pergunta: id_perguntaAv,
                obs: (obsAv || "").toString().trim() || null,
            };

            const config = authToken
                ? { headers: { "x-access-token": authToken } }
                : undefined;

            await api.post("/satisfacao/avalia/", param, config);
            setObsAv('');
            setQuestion(question + 1);

        } catch (e) {
            console.error(e);
            setErrMsg("Não foi possível salvar. Tente novamente.");
        } finally {
            setSaving(false);
        }
    }

    return (
        <div className="ps-question-card">
            <h2 className="ps-question-text">{pergunta}</h2>

            <div className="ps-scale" role="group" aria-label="Avaliação">
                {options.map((opt) => (
                    <BtnExpand
                        key={opt.nota}
                        valor={opt.label}
                        cor={opt.cor}
                        nota={opt.nota}
                        id_pergunta={id_pergunta}
                        selected={notaAv === opt.nota}
                        onSelect={onSelect}
                    />
                ))}
            </div>

            <textarea
                className="ps-obs"
                placeholder="Digite sua observação (opcional)"
                aria-label="Observação"
                value={obsAv || ""}
                onChange={(e) => setObsAv(e.target.value)}
            />

            <div className="ps-actions">
                <button type="button" className="ps-btn-primary" disabled={saving} onClick={handleSalvar}>
                    {saving ? "Salvando..." : "Salvar"}
                </button>
                <button type="button" className="ps-btn-ghost" onClick={() => setQuestion(question + 1)}>
                    Pular
                </button>
            </div>

            {!!errMsg && (
                <div className="ps-error" role="alert">{errMsg}</div>
            )}

            {isModalOpen && question === 0 && (
                <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
                    <div
                        className="modal-content"
                        onClick={(e) => e.stopPropagation()}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="agradecimentos-title"
                    >
                        <h2 id="agradecimentos-title">Agradecimentos!</h2>
                        <p>
                            Prezado(a) paciente, agradecemos por dedicar um momento para
                            participar da nossa pesquisa de satisfação. Sua opinião é
                            fundamental para aprimorarmos constantemente nossos serviços...
                        </p>
                        <button onClick={() => setIsModalOpen(false)}>OK</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BodyElement;